import React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { connect } from 'react-redux';
import setSearchProductAction from '../../redux/actions/searchReferenceActions/actionSearchProducts'
import { withTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';

const StyledTextField = styled(TextField)({
    '& .MuiOutlinedInput-notchedOutline': {
      '&:hover': {
        borderColor: "rgb(0,191,255)",
      },
      '&.Mui-focused': {
        borderColor: "rgb(47, 79, 79)",
      },
    },
    '& .Mui-focused': {
      color: 'white',
    },
    width: 300,
    fontSize: 30,
    backgroundColor: 'rgba(19, 174, 236, 0.54)',
    fontWeight: 'bold'
  });

const filterOptions = createFilterOptions({
    ignoreAccents: true,
    limit: 20,
});

class SearchProductForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = { product: '', productnumber: '', products: { data: [{ 'productname': '', 'productnumber': '' }] } };
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeForm = this.handleChangeForm.bind(this);
        this.props.setSearchProductFunction('')
    }
    // fetch by adding charachters in product-inputform
    handleChange(event) {
        this.setState({ product: event.target.value }, async () => {
            if (this.state.product !== null) {
                const response = await fetch(`${process.env.REACT_APP_EXPRESS_SERVER}/searchRef/product?product=${this.state.product}`);
                const json = await response.json();
                this.setState({ products: json });
            }
        });
    };

    handleChangeForm(event, value) {

        // console.log(this.state.products)
        if (value !== null) {

            this.setState({ productnumber: value.productnumber }, () => {
                this.props.setSearchProductFunction(this.state.productnumber)
            });
        } else {
            this.setState({ productnumber: '' }, () => {
                this.props.setSearchProductFunction(this.state.productnumber);
            });
        }
    }

    render() {

        const { classes } = this.props;
        const { t } = this.props;

        return (

            <div>
                <Autocomplete
                    classes={classes}
                    id="combo-box-product"
                    limitTags={1}
                    // autoComplete={true}
                    onChange={this.handleChangeForm}
                    filterOptions={filterOptions}
                    options={this.state.products.data}
                    getOptionLabel={(option) => option.productname || ""}
                    isOptionEqualToValue={(option, value) => option.productname === value.productname}
                    noOptionsText={'Wrong input data'}
                    style={{ width: 300, margin: 10, }}
                    renderInput={(params) => (<StyledTextField {...params} style={{ fontSize: 30, backgroundColor: 'rgba(19, 174, 236, 0.54)' }}
                        onChange={this.handleChange} variant="outlined" label={t("create_ref.products_label")} placeholder={t("create_ref.products_placeholder")} />)}
                />
            </div>
        );

    }
}

function mapDispatchToProps(dispatch) {
    return {
        setSearchProductFunction: searchProduct => {
            dispatch(setSearchProductAction(searchProduct))
        }
    }
}

export default connect(null, mapDispatchToProps)(withTranslation()(SearchProductForm));